

<template>
      
      



      <div class="card card-bordered mb-1" v-for="gorusmebilgi in paginatedgorusmebilgiler" :key="gorusmebilgi.id">
   
   <div class="project d-flex g-2">
   
    
     <div class="p-2" style="flex: 4">
     <div class="project-center flex-grow-1" >
       <div class="project-head">
         <h6 class="title" @click="detay(gorusmebilgi)">{{ gorusmebilgi.firma_ad }}</h6>
        
         <div class="drodown">
           
           <a href="#" class="btn btn-trigger btn-icon"  v-if="yetki_kontrol('gorusmebilgi_goster')"   @click="detay(gorusmebilgi)">
            <em class="icon ni ni-eye"></em>
           </a>

           <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('gorusmebilgi_duzenle')" @click="duzenle(gorusmebilgi)">
             <em class="icon ni ni-pen"></em>
           </a>


           <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('gorusmebilgi_sil')" @click="sil(gorusmebilgi.id)">
             <em class="icon ni ni-trash-alt"></em>
           </a>
         </div>
       </div>
  
       <ul class="team-statistics">
         <li>
           <div class="project-title d-flex align-items-center">
             <div class="user-avatar sq bg-purple">
               <img :src="$globalVariable.uploadUrl + gorusmebilgi.firma_logo" @error="$globalVariable.varsayilanGorsel" />
             </div>
             <div class="project-info">
               <p  class="title">{{ gorusmebilgi.firma_ad }}</p>
               <span class="sub-text">{{ gorusmebilgi.firma_ulke }}</span>
             </div>
           </div>

         </li>
         <li><span>{{ gorusmebilgi.etkinlik_ad }}</span><span>Etkinlik Adı</span></li>
         <li><span>{{ gorusmebilgi.kisi_ad }}</span><span>Firma Tesilcisi</span></li>
         <li><span>{{ gorusmebilgi.gorusmeyapan_ad }}</span><span>Görüşmeyi Yapan Kişi</span></li>
       </ul>
       <div class="kanban-item-meta">
         <ul class="kanban-item-meta-list">
           <li><em class="icon ni ni-calendar"></em><span>{{$globalVariable.formatDateTime(gorusmebilgi.tarih)  }}</span></li>
         </ul>
         <ul class="kanban-item-meta-list">
           <li v-if="gorusmebilgi.hizliekleme==1"><span class="badge badge-dim bg-warning"><em class="icon ni ni-loader"></em><span>Hızlı Ekleme</span></span></li>
         </ul>
       </div>
     </div> 
     </div>

     
   </div>

</div>




<div class="card-inner">
        <div class="nk-block-between-md g-3">
          <div class="g">
            <ul class="pagination justify-content-center justify-content-md-start">
              <li :class="{ active: page === gorusmebilgiler.seciliSayfa, 'page-item': true }" v-for="page in pages"
                :key="page">
                <a class="page-link" href="#" @click="gorusmebilgilerSayfaDegistir(page)">{{ page }}</a>
              </li>

            </ul>
          </div>

        </div>
      </div>




   

 </template>
 

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {

    gorusmebilgiler:{
      type: Array,
      required: true
    },
    duzenle: Function,
    detay: Function,
    formKaydetSonrasi: Function,
    tur:String,
  },
  computed: {
    filteredgorusmebilgiler() {
  // Arama filtresine göre kullanıcıları filtrele
  return this.gorusmebilgiler.tumu.filter((gorusmebilgi) => {
    const arananKelime = this.gorusmebilgiler.arananKelime.toLowerCase();

    return (
      (gorusmebilgi.oncelik?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.ziyaretcitipi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.aktivitetipi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.malzemealtyapi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.taslamapersonelsayi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.malzemekalinligiaraligi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.malzemegenislikaraligi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.malzemekalitesi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.malzemesekli?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.tutucusistem?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.dogrultmamalzemekalinlikaraligi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.dogrultmamaksimumparcagenisligi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.dogrultmamaksimummalzemeboyu?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.dogrultmaaranilanduzlemselliktoleransi?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.manuelcapakalmavekenaryuvarlamamakinesinot?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.not?.toLowerCase() || '').includes(arananKelime) ||
      (gorusmebilgi.seskaydi?.toLowerCase() || '').includes(arananKelime)
    );
  });
},

    paginatedgorusmebilgiler() {
      const start = (this.gorusmebilgiler.seciliSayfa - 1) * this.gorusmebilgiler.sayfadaKayit;
      const end = start + this.gorusmebilgiler.sayfadaKayit;
      return this.filteredgorusmebilgiler.slice(start, end);
    },
    gorusmebilgiler_toplamSayfa() {
      const totalFilteredUsers = this.filteredgorusmebilgiler.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.gorusmebilgiler.sayfadaKayit), 1);
      if (this.gorusmebilgiler.seciliSayfa > maxPage) {
        this.gorusmebilgilerSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
        const totalPageCount = this.gorusmebilgiler_toplamSayfa;
        const maxVisiblePages = 5;
        const currentPage = this.gorusmebilgiler.seciliSayfa;

        if (totalPageCount <= maxVisiblePages) {
            return Array.from({ length: totalPageCount }, (_, index) => index + 1);
        }

        const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

        return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    async sil(gorusmebilgiId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("gorusmebilgiler/sil/" + gorusmebilgiId);
          this.$toast.success("Kayıt Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    gorusmebilgilerSayfaDegistir(page) {
      this.$emit('update:gorusmebilgiler',{
      ...this.gorusmebilgiler,
      seciliSayfa: page
    });
    },
    gorusmebilgilerSayfadaKayitDegistir(value) {
      this.$emit('update:gorusmebilgiler',{
      ...this.gorusmebilgiler,
      sayfadaKayit: value
    });
      this.gorusmebilgilerSayfaDegistir(1);
    },
  },
};
</script>
